import { render, staticRenderFns } from "./publicSidebar.vue?vue&type=template&id=0296c84a&scoped=true&"
import script from "./publicSidebar.vue?vue&type=script&lang=js&"
export * from "./publicSidebar.vue?vue&type=script&lang=js&"
import style0 from "./publicSidebar.vue?vue&type=style&index=0&id=0296c84a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296c84a",
  null
  
)

export default component.exports